import { useMobileOrientation } from "react-device-detect";
import { useTranslation } from "react-i18next";

const MouseDisclaimer: React.FC<any> = ({ style }) => {
  const { t } = useTranslation("radar");
  const { isPortrait } = useMobileOrientation();

  return (
    <span style={style}>
      {isPortrait
        ? t("pages.CareerDiagnose.chartHoverDisclaimerMobile")
        : t("pages.CareerDiagnose.chartHoverDisclaimer")}
    </span>
  );
};

export default MouseDisclaimer;
